import APPasswordReset from './APPasswordReset';

export {
    APPasswordReset
};

export default APPasswordReset;
